module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp2_3009.a08414fa.png";